import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ToolsOverview } from './overview';
import { BmpCalculator } from './bmpCalculator';
import { ExactIntegrationSettings } from './exactIntegrationSettings';
import { DwhStatus } from "./dwhStatus";

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class ToolsPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return (
      <Container>
        <Switch>
          <Route path="(.*)/dwh-status" component={DwhStatus} />
          <Route path="(.*)/bmp-calculator" component={BmpCalculator} />
          <Route path="(.*)/exact-integration" component={ExactIntegrationSettings} />
          <Route component={ToolsOverview} />
        </Switch>
      </Container>
    );
  }
}

ToolsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ToolsPage = compose(
  withConnect,
  withRouter,
)(ToolsPageComp);
